<div *ngIf="flag" class="purchase-history">
  <fleet-profile-jumbotron class="fleet-profile-jumbotron"
    [userProfile]="userProfile"
  ></fleet-profile-jumbotron>
  <div class="container">
    <div class="row purchase-row">
      <div class="col-md-10 purchase">{{translationProductDescription['purchase_history.purchase']}}</div>
      <div class="col-md-2 icon-container" (click)="printPage()">
        <div class="print-icon"><space-icon class="icon print" icon="print" outline="false"> </space-icon></div>
        <span class="print">{{translationProductDescription['purchase_history.print']}}</span>
      </div>
    </div>
    <div class="row message">
      <div class="col-md-10">
        {{translationProductDescription['purchase_history.message']}}
      </div>
    </div>
    <div class="row search-bar">
      <div class="col search-history">
        <space-text-field
          inputid="vinSearch"
          icon="adas"
          [label]="translationProductDescription['purchase_history.search']"
          (keyup)="findBy($event)"
          svg="{{ downloadSvg }}"
        ></space-text-field>
        <!-- <span class="search-icon"
          ><space-icon icon='magnifyglass' outline='true'></space-icon>
        </span> -->
      </div>
    </div>
    <div class="row content-font">
      <div class="col">
        <div class="flexi-table-container" role="table">
          <div class="flexi-row header" role="rowgroup">
            <div
              class="flexi-col"
              role="columnheader"
              [innerHTML]="translationProductDescription['purchase_history.product']"
            ></div>

            <div class="flexi-col  arrow-flex" role="columnheader" >
              <div class="arrow">
               {{translationProductDescription['purchase_history.date']}}
              </div>
              <div>
                <div class="ascDate arrow-margin" (click)="sortByDate('asc')" [class.blue]="isDateAsc">
                  <space-icon icon="chevronupmedium" outline="true">
                  </space-icon>
                </div>
                <div class="dscDate" (click)="sortByDate('dsc')" [class.blue]="isDateDsc">
                  <space-icon icon="chevrondownmedium" outline="true">
                  </space-icon>
                </div>
              </div>
            </div>

            <div class="flexi-col arrow-flex" role="columnheader">
              <div class="arrow">
                {{translationProductDescription['purchase_history.invoice']}}
              </div>
              <div>
                <div class="arrow-margin ascInvoice" (click)="sortByInvoice('asc')" [class.blue]="isInvoiceAsc">
                  <space-icon icon="chevronupmedium" outline="true">
                  </space-icon>
                </div>
                <div class="dscInvoice" (click)="sortByInvoice('dsc')" [class.blue]="isInvoiceDsc">
                  <space-icon icon="chevrondownmedium" outline="true">
                  </space-icon>
                </div>
              </div>
            </div>
            <div
              class="flexi-col"
              role="columnheader"
              [innerHTML]="translationProductDescription['purchase_history.vin']"
            ></div>
            <div
              class="flexi-col"
              role="columnheader"
              
            >
            <div [innerHTML]="translationProductDescription['purchase_history.price']"></div>
            <div class="sub-heading" [innerHTML]="translationProductDescription['purchase_history.subPrice']"></div></div>
            <div
            class="flexi-col"
            role="columnheader"
          
          ></div>
          </div>
          
          <div
            class="flexi-row empty-purchase-history"
            role="rowgroup"
            *ngIf="_purchaseList.length === 0"
          >
            <div class="flexi-col row-padding-left" role="cell">{{translationProductDescription['purchase_history.noVehicles']}}</div>
          </div>
          <div  *ngFor="let product of _purchaseList[pageNum]">
          <div
            class="flexi-row purchase-history-data"
            role="rowgroup"
            *ngFor="let subs of product['subscriptions']"
          >
            <div
              class="flexi-col"
              role="cell"
             
            >
              {{ subs['ProductName'] }}
            </div>
            <div class="flexi-col" role="cell">
              {{ changeDateFormat(product['invoiceTargetDate']) }}
            </div>
            <div class="flexi-col" role="cell">
              {{ product['invoiceNumber'] }}
            </div>
            <div
              class="flexi-col"
              role="cell"
             
            >
              {{ subs['vin'] }}
            </div>
            <div class="flexi-col" role="cell">${{ product['amount'] }}</div>
            <div class="flexi-col" role="cell">
             <space-btn
                aria_label="btn"
                id_btn=""
                disabled="false"
                tab_index=""
                variant="btn1Picto"
                warning="false"
                alternative="false"
                icon="right"
                select="false"
                label="2 line"
                type="picto text"
                svg="{{ downloadSvg }}"
                size="default"
                picto="right"
                alignment="left"
                (clickEvent)="downloadInvoice(product)"
              >
                Download
              </space-btn> 
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-16" *ngIf="_purchaseList.length > 1">
      <div class="col">
        <div class="pagination">
          <span class="prev-icon" (click)="prevPage()" [ngClass]="{'prev-icon-black': (pageNum + 1 > 1) || (pageNum + 1 == _purchaseList.length)}">
            <space-icon icon="chevronleftlarge" outline="false"> </space-icon>
          </span>
          <span class="pagination-num">{{pageNum + 1}}/{{_purchaseList.length}}</span>
          <span class="next-icon" (click)="nextPage()" [ngClass]="{'next-icon-black': (pageNum + 1 === _purchaseList.length) }">
            <space-icon icon="chevronrightlarge" outline="false"> </space-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
